// extracted by mini-css-extract-plugin
module.exports = {"ConfirmModal":"ConfirmModal_ConfirmModal__1wxid"};